export default {
  type: "string",
  example: "CHANGE THIS"
};
